import { type Product } from '@atlassian/expansion-services/services';

export const ProductDisplayNameMap: Partial<Record<Product, string>> = {
	confluence: 'Confluence',
};

export type SupportedProduct = keyof typeof ProductDisplayNameMap;

export interface InvitePanelProps {
	emails: string[];
	integration: string;
	isRecaptchaLoaded: boolean;
	onDismiss: () => void;
	onInvite: () => Promise<void>;
	product: SupportedProduct;
}
